import { useIntl } from 'react-intl'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

function CartPanelPreparingBanner() {
  const intl = useIntl()

  return (
    <MessageBanner kind="informational" density="compact" icon={<LineInfoCircleIcon />}>
      {intl.formatMessage({
        id: 'I76wUEnLJHiJBjc2bkZ7',
        defaultMessage: 'Getting this ready for checkout',
        description: 'Trip planner cart note shown while a saved item with all its details is still being added to the cart for checkout',
      })}
    </MessageBanner>
  )
}

export default CartPanelPreparingBanner
